import { IonContent } from '@ionic/react';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import { useManLayoutSelections } from '@/pages/Onboarding/hooks/useManLayoutSelections';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import {
  ActionsLabelStyles,
  ActionsStyles,
  PageStyles,
  PhraseStyles,
  StoreLinksStyles,
} from './Paymentless.styles';

const PaymentlessVariant: React.FC = () => {
  const { user } = useAccount();

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  const {
    ageGeneration: womanAgeGeneration,
    bodyShape: womanBodyShape,
    hairColor: womanHairColor,
  } = useLayoutSelections();

  const {
    ageGeneration: manAgeGeneration,
    bodyShape: manBodyShape,
    ethnicity: manEthnicity,
  } = useManLayoutSelections();

  const getMainImageSrc = () => {
    if (webCampaign.aiGender === 'man') {
      return `../assets/success-page/paymentless/${webCampaign.aiGender}/${manAgeGeneration}_${manEthnicity}_${manBodyShape}.png`;
    }

    return `../assets/success-page/paymentless/${webCampaign.aiGender}/${womanAgeGeneration}_${womanHairColor}_${womanBodyShape}.png`;
  };

  return (
    <PageStyles
      background={webCampaign.getStaticTheme()}
      bgImage={
        <img
          src={getMainImageSrc()}
          alt="Main AI"
          onError={(e) => {
            if (webCampaign.aiGender === 'man') {
              e.currentTarget.src =
                '../assets/success-page/paymentless/man/young_european_muscular.png';
              return;
            }

            e.currentTarget.src =
              '../assets/success-page/paymentless/women/young_blonde_skinny.png';
          }}
        />
      }
      bgImageMask={false}
    >
      <IonContent>
        <PhraseStyles>
          <img
            src="../assets/success-page/paymentless/cant-wait-phrase.png"
            alt="Can't wait"
          />
        </PhraseStyles>

        <ActionsStyles>
          <ActionsLabelStyles
            align="center"
            variant="body-large"
            className="action-description"
          >
            Download <span className="app-name-colored">Dialogue</span>
          </ActionsLabelStyles>
          <StoreLinksStyles>
            <a
              href={downloadingAppLink}
              onClick={() => fireAmplitude('appstore')}
            >
              <img
                src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/appstore.png"
                alt="appstore"
              />
            </a>
            <a
              href={downloadingAppLink}
              onClick={() => fireAmplitude('googleplay')}
            >
              <img
                src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/googleplay.png"
                alt="googleplay"
              />
            </a>
          </StoreLinksStyles>
        </ActionsStyles>
      </IonContent>
    </PageStyles>
  );
};

export default PaymentlessVariant;
